import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@journ/ui/alert-dialog'
import { Textarea } from '@journ/ui/textarea'
import { useIntlayer } from 'react-intlayer'
import { useSelector } from '@/libs/state'
import {
	cancelReason$,
	rejectReason$,
	showArchive$,
	showCancel$,
	showReject$,
} from '../../work-item-detail-store'
import { useWorkItemDetailContext } from './work-item-detail-context'

const WorkItemDialogs = () => {
	const { detail } = useWorkItemDetailContext()
	const { openSpawnCount, onConfirmCancel, onConfirmReject, onConfirmArchive } = detail
	const c = useIntlayer('work-item').detail
	const showCancel = useSelector(showCancel$)
	const showReject = useSelector(showReject$)
	const showArchive = useSelector(showArchive$)
	const cancelReason = useSelector(cancelReason$)
	const rejectReason = useSelector(rejectReason$)

	return (
		<>
			<AlertDialog open={showCancel} onOpenChange={showCancel$.set}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>{c.cancelAction}</AlertDialogTitle>
						<AlertDialogDescription>{c.cancelReasonPlaceholder}</AlertDialogDescription>
					</AlertDialogHeader>
					<Textarea
						value={cancelReason}
						onChange={e => cancelReason$.set(e.target.value)}
						placeholder={c.cancelReasonPlaceholder.value}
						autoFocus
					/>
					<AlertDialogFooter>
						<AlertDialogCancel>{c.dismiss}</AlertDialogCancel>
						<AlertDialogAction disabled={!cancelReason.trim()} onClick={onConfirmCancel}>
							{c.cancelConfirm}
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>

			<AlertDialog open={showReject} onOpenChange={showReject$.set}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>{c.rejectAction}</AlertDialogTitle>
						<AlertDialogDescription>{c.rejectReasonPlaceholder}</AlertDialogDescription>
					</AlertDialogHeader>
					<Textarea
						value={rejectReason}
						onChange={e => rejectReason$.set(e.target.value)}
						placeholder={c.rejectReasonPlaceholder.value}
						autoFocus
					/>
					<AlertDialogFooter>
						<AlertDialogCancel>{c.dismiss}</AlertDialogCancel>
						<AlertDialogAction disabled={!rejectReason.trim()} onClick={onConfirmReject}>
							{c.rejectConfirm}
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>

			<AlertDialog open={showArchive} onOpenChange={showArchive$.set}>
				<AlertDialogContent>
					<AlertDialogHeader>
						<AlertDialogTitle>{c.archiveAction}</AlertDialogTitle>
						{openSpawnCount > 0 ? <AlertDialogDescription>{c.archiveOpenSpawnsWarning}</AlertDialogDescription> : null}
					</AlertDialogHeader>
					<AlertDialogFooter>
						<AlertDialogCancel>{c.dismiss}</AlertDialogCancel>
						<AlertDialogAction onClick={onConfirmArchive}>
							{openSpawnCount > 0 ? c.archiveForceLabel : c.archiveConfirm}
						</AlertDialogAction>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialog>
		</>
	)
}

export { WorkItemDialogs }
